goog.provide("shadow.js.shim.module$src$svg$objects$eye_svg$default");
shadow.js.shim.module$src$svg$objects$eye_svg$default = shadow.js.shim.module$src$svg$objects$eye_svg.default;
